import { Box } from "@amzn/awsui-components-react";
import { formatLatencyChange, formatLatencyMs, latencyValue } from "../../utils/mapReleaseDashboard/recostLatencyMetrics";

/** Shows the relative change first, with measured timings and paired coverage available on demand. */
const RecostLatencyChange = ({ change, control, candidate, pairedCount, recordCount }: {
    change: number | null | undefined;
    control: number | null | undefined;
    candidate: number | null | undefined;
    pairedCount?: number | null;
    recordCount?: number | null;
}) => {
    const controlMs = latencyValue(control);
    const candidateMs = latencyValue(candidate);
    const pairs = latencyValue(pairedCount);
    const records = latencyValue(recordCount);
    return (
        <Box>
            <Box fontWeight="bold">{formatLatencyChange(change)}</Box>
            <details>
                <summary>Latency details</summary>
                <Box variant="small" display="block">Control: {formatLatencyMs(controlMs)}</Box>
                <Box variant="small" display="block">Candidate: {formatLatencyMs(candidateMs)}</Box>
                <Box variant="small" display="block">Paired requests: {pairs === null ? "N/A" : pairs.toLocaleString("en-US")}</Box>
                <Box variant="small" display="block">Selected records: {records === null ? "N/A" : records.toLocaleString("en-US")}</Box>
                {controlMs === 0 && candidateMs !== null && (
                    <Box variant="small" display="block">Percentage change is undefined when control is zero.</Box>
                )}
                {(controlMs === null || candidateMs === null) && (
                    <Box variant="small" display="block">Latency measurements are unavailable for this comparison.</Box>
                )}
                <Box variant="small" display="block">Client latency includes transport, retries and retry backoff.</Box>
            </details>
        </Box>
    );
};

export default RecostLatencyChange;
